export enum Claims {
    feasy_users = 'FeasyUsers',
    feasy_restricted_users = 'FeasyRestrictedUsers',
    feasy_admins = 'FeasyAdmins'    
}
